import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { footerImg } from "../data/data";
import { HeartFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";
const Wrapper = styled.div`
  .img-container {
    font-size: auto;
  }
  img {
    height: 430px;
    width: 100%;
    object-fit: cover;
    object-position: top center;
  }
  .main {
    position: relative;
  }
  .caption {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    display: grid;
    place-items: center;
  }

  .thank,
  .you {
    font-size: 55px;
    line-height: 10px;
  }

  .thank-you {
    text-align: center;
    color: #fff;
    font-family: "Pacifico", cursive;
    transform: rotate(-10deg);
    padding-right: 30px;
    margin-top: 40px;
    margin-bottom: 25px;
  }
  .wrap {
    text-align: center;
    padding: 15px 0;
  }
  .couple-name {
    font-family: "Oswald", sans-serif;
    font-size: 20px;
    color: #fff;
    letter-spacing: 3px;
    margin-top: 10px;
    text-transform: uppercase;
  }
`;

export default function Footer() {
  const [footer, setFooter] = useState([]);
  useEffect(() => {
    const filtered = footerImg.filter(
      (footerPic) => footerPic.showHome === true
    );
    setFooter(filtered);
  }, []);

  return (
    <>
      <Wrapper>
        <div className="img-container">
          {footer &&
            footer.map((foot) => (
              <div className="main" key={foot.id}>
                <img src={foot.image} alt="pic" />
                <div className="caption">
                  <div>
                    <h3 className="thank thank-you">Thank</h3>
                    <p className="you thank-you">You</p>
                    <div className="wrap">
                      <HeartStyle>
                        <span className="white-line"></span>
                        <HeartFilled
                          style={{ fontSize: 19, zIndex: 20, color: "red" }}
                        />
                        <HeartFilled
                          style={{
                            fontSize: 19,
                            marginLeft: -5,
                            color: "white",
                          }}
                        />
                        <span className="white-line"></span>
                      </HeartStyle>
                      <h3 className="couple-name">Lordvic & Ufedo</h3>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </Wrapper>
    </>
  );
}
